import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Card, CardBody, Modal } from "reactstrap";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import search from "../../../assets/images/search-lg.svg";
import NormalCardHeader from "../../../Common/CardHeader/NormalCardHeader";
import { deleteOneSize, getAllSize } from "../../../../redux/size/action";
import CommonPagination from "../../../Common/Pagination/CommonPagination";
import DeleteSize from "../Size/DeleteSize";
import {
  deleteOneOccassion,
  getAllOccassion,
} from "../../../../redux/occassion/action";
import * as XLSX from "xlsx";
import axiosInstance from "../../../../redux/api";
import DeleteOccassion from "./DeleteOcassion";
import { usePermissions } from "../../../../Hooks/usePermissions";
import { MENU, PERMISSION } from "../../../../lib/permissions";

const OccassonList = () => {
  const { hasAction } = usePermissions();
  const [params, setParams] = useState({
    page: 1,
    search_key: "",
    status: "",
  });
  console.log(params, "one");
  const { t } = useTranslation();
  const [openFilter, setOpenFilter] = useState(false);
  const [modal, setModal] = useState(false);
  const [currentComponent, setCurrentComponent] = useState({});
  const [loading, setLoading] = useState(false);
  const [componentList, setComponentList] = useState([]);
  const [searchtext, setSearchtext] = useState(params?.search_key || "");
  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 10;
  const occassionList = useSelector(
    (state) => state.reusableSlice.occassionList
  );
  console.log(occassionList, "sdfsfsfsf");
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const addComponent = () => {
    navigate("/addoccassion");
  };

  const updateComponent = (id) => {
    navigate(`/upadteoccassion/${id}`);
  };

  useEffect(() => {
    dispatch(getAllOccassion(params));
  }, [dispatch, params]);

  const deleteComponent = () => {
    if (currentComponent && currentComponent.id) {
      dispatch(deleteOneOccassion(currentComponent?.id));
    } else {
      console.error("No valid ID found for the component to delete.");
    }
  };

  useEffect(() => {
    const debounceTimeout = setTimeout(() => {
      setParams((prevParams) => ({
        ...prevParams,
        search_key: searchtext,
        page: 1,
      }));
    }, 500);
    return () => clearTimeout(debounceTimeout);
  }, [searchtext]);

  const filteredItems = params.status
    ? occassionList.filter((item) => item.status === parseInt(params.status))
    : occassionList;

  const totalPages = Math.ceil(filteredItems.length / itemsPerPage);
  const currentPageItems = filteredItems.slice(
    (currentPage - 1) * itemsPerPage,
    currentPage * itemsPerPage
  );

  // csv file convert
  const handleExportOccassions = async (e) => {
    e.preventDefault();
  
    const filterParams = {
      ...params,
      page: "", 
    };


    try {
      const response = await axiosInstance.post(`occasion/get_all`, filterParams  );
  
      const occassionList = response?.data?.response || [];
  
      if (!occassionList.length) return;
  
      const header = [
        ["Sl", "Name", "Show in Home", "Status", "Created On", "Updated By"],
      ];
  
      const data = occassionList.map((item, index) => [
        index + 1,
        item.name,
        item.home_view ? "Yes" : "No",
        item.status === 1 ? "Active" : item.status === 2 ? "Inactive" : "",
        new Date(item.created_on).toLocaleString("en-US", { timeZone: "UTC" }),
        item.updated_by_name || "",
      ]);
  
      const worksheet = XLSX.utils.aoa_to_sheet(header);
      XLSX.utils.sheet_add_aoa(worksheet, data, { origin: "A2" });
  
      const workbook = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(workbook, worksheet, "Occasion List");
  
      XLSX.writeFile(workbook, "OccasionList.xlsx");
    } catch (error) {
      console.error("Occasion Export Error:", error);
    }
  };
  
  // permission delete
  const canDelete = hasAction(MENU.CATALOGUE, PERMISSION.DELETE);

      
      

  return (
    <div className="card-head order-card order-timing">
      <div className="mb-3">
        <h4>Occasion List</h4>
      </div>
      {/* <div
        onClick={() => setOpenFilter(false)}
        className={openFilter ? `overlay show` : "overlay"}
      ></div> */}
      {/* <OfferFilter
        openFilter={openFilter}
        setOpenFilter={setOpenFilter}
        params={params}
        setParams={setParams}
      /> */}
      <NormalCardHeader
        params={params}
        setParams={setParams}
        addmodel={addComponent}
        search={search}
        setOpenFilter={setOpenFilter}
      />
      <div className="table-category mt-3">
        <div className="table-first-top d-flex justify-content-between align-items-center">
          {/* <h6>{filteredItems.length} Occasions</h6> */}
          <h6> </h6>
          <div className="d-flex justify-content-end align-items-center table-right">
            Filter by
            <select
              onChange={({ target }) =>
                setParams((prevParams) => ({
                  ...prevParams,
                  status: target.value,
                  page: 1,
                }))
              }
            >
              <option value="">All</option>
              <option value="1">Active</option>
              <option value="2">Inactive</option>
            </select>
            <button
              className="btn btn-primary"
              onClick={handleExportOccassions}
            >
              Export CSV
            </button>
          </div>
        </div>
        <div className="table-sec table-responsive">
          <table className="table">
            <thead>
              <tr>
                <th scope="col">Name</th>
                <th scope="col" className="item_name">Show in Home</th>
                {/* <th scope="col">Position</th> */}
                <th scope="col">Status</th>
                <th scope="col">Uploaded on</th>
                <th scope="col" className="text-center">
                  Action
                </th>
              </tr>
            </thead>
            <tbody>
              {currentPageItems.length > 0 ? (
                currentPageItems.map((item, index) => (
                  <tr key={index}>
                    <td>
                      <div className="d-flex td-img align-items-center">
                        <img
                          src={item?.image || "https://placehold.co/100x100"}
                          alt={item?.title || "Image"}
                          style={{
                            width: "50px",
                            height: "50px",
                            objectFit: "cover",
                          }}
                        />
                        <h6>{item?.name}</h6>
                      </div>
                    </td>
                    <td>{item?.home_view ? "Yes" : "No"}</td>
                    {/* <td>{item?.position}</td> */}
                    <td
                        style={{
                          color:
                            item.status === 1
                              ? "#12b812"
                              : item.status === 2
                              ? "red"
                              : "inherit",
                        }}
                      >
                        <div
                          className=""
                          style={{
                            backgroundColor:
                              item.status === 1
                                ? "#16d11630"
                                : item.status === 2
                                ? "#ff000026"
                                : "inherit",
                            padding: "3px 25px",
                            borderRadius: "50px",
                            textAlign: "center",
                            width: "fit-content",
                          }}
                        >
                          {item.status === 1
                            ? "Active"
                            : item.status === 2
                            ? "Inactive"
                            : ""}
                        </div>
                      </td>
                    <td>
                      {new Date(item?.created_on).toLocaleString("en-US", {
                        timeZone: "UTC",
                      })}
                      <br />
                      {item.updated_by_name ? item.updated_by_name : ""}
                    </td>
                    <td>
                    <div class="dropdown d-flex justify-content-center">
                          <button
                            class="dropdown-action-btn dropdown-toggle"
                            type="button"
                            id="dropdownMenuButton"
                            data-toggle="dropdown"
                            aria-haspopup="true"
                            aria-expanded="false"
                          >
                            Action
                          </button>
                          <div
                            class="dropdown-menu"
                            aria-labelledby="dropdownMenuButton"
                          >
                            <a
                              class="dropdown-item"
                              onClick={() => updateComponent(item.id)}
                            >
                              Edit
                            </a>
                            {canDelete && (
                              <a
                                class="dropdown-item"
                                onClick={() => {
                                  setModal(true);
                                  setCurrentComponent(item);
                                }}
                              >
                                Delete
                              </a>
                            )}
                          </div>
                        </div>
                    </td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan="11" className="text-center">
                    No occasion found
                  </td>
                </tr>
              )}
            </tbody>
          </table>
          <CommonPagination
            currentPage={currentPage}
            totalPages={totalPages}
            onPageChange={setCurrentPage}
          />
        </div>
      </div>
      <Modal isOpen={modal} toggle={() => setModal((state) => !state)}>
        <DeleteOccassion
          setModal={setModal}
          currentComponent={currentComponent}
          deleteComponent={deleteComponent}
        />
      </Modal>
    </div>
  );
};

export default OccassonList;
